








































































import Vue from 'vue';
import { RoleService } from '@/services/RoleService';
import { RoleModel } from '@/types/models/role';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { FormFieldValidation, ModalHelpers } from '@/mixins';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { NotificationPresentationType } from '@/types';

export default Vue.extend({
  name: 'EditRole',
  mixins: [FormFieldValidation, ModalHelpers],
  data() {
    return {
      role: {} as RoleModel,
      isLoading: false,
      submitIsLoading: false,
      errorMessage: ''
    };
  },
  methods: {
    getRole(this: any) {
      this.isLoading = true;
      RoleService.getRoleAsync(this.$route.params.id)
        .then((result: any) => {
          if (result && !result.canEdit) {
            this.$router.push({
              name: 'errorPage',
              params: {
                errorCode: '401',
                errorMessage: 'Sorry, you do not have permission to edit this role.',
                notificationPresentationType: NotificationPresentationType.UserActionRequired
              }
            });
          }
          this.role = result;
          this.isLoading = false;
        })
        .catch((error: any) => {
          this.isLoading = false;
        });
    },
    onSubmit(this: any) {
      this.submitIsLoading = true;
      RoleService.updateRoleAsync(this.role.id, this.role)
        .then((response) => {
          SnotifyConfiguration.showSuccess('Role successfully updated.');
          this.submitIsLoading = false;
          this.setApplicationDirty(false);
          this.$router.push({ name: 'roleManagement' });
        })
        .catch((error) => {
          this.$validator.errors.remove('serverValidationErrors');
          this.$validator.errors.add({
            field: 'serverValidationErrors',
            msg: error.notification
          });
          this.submitIsLoading = false;
        });
    },
    async cancel(this: any) {
      this.$router.push({ name: 'roleManagement' });
    }
  },
  mounted(this: any) {
    this.getRole();
  },
  components: {
    LoadingSpinner
  }
});
